import React from 'react'
import './shorts.css'
import ME from '../../assets/shortsimg.png'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'

const Shorts = () => {
  return (
    <section id='shorts'>
      <h5>Some more</h5>
      <h2>Interesting Stuffs</h2>

      <div className="container about__container">
        <div className="shorts__me">
          <div className="shorts__me-image">
            <img src={ME} alt="About Image" />
          </div>
        </div>
        <div className="about__content">
          
          <blockquote>
          Looking for a fun and easy way to learn about the latest developments in technology? Our YouTube channel offers a range of shorts and reels covering Python, AI tools, funny tech-related reels, and trending news in the tech world. Whether you're a seasoned programmer or just starting out, our content is designed to inform and entertain in a quick and engaging way. Our videos are perfect for anyone who wants to learn something new and interesting without investing a lot of time. So why not check out our YouTube channel today and join our community of tech enthusiasts? Don't forget to hit the like, comment, and subscribe buttons to stay up-to-date with our latest releases!








          </blockquote>
          <br />
            <a href="https://www.youtube.com/@ataglanceofficial/shorts" target="_blank" className='btn btn-primary'>Watch Reels / Shorts Video!</a>
        </div>
      </div>
    </section>
  )
}

export default Shorts